import script from "./commentWall.vue?vue&type=script&setup=true&lang=js"
export * from "./commentWall.vue?vue&type=script&setup=true&lang=js"

import "./commentWall.vue?vue&type=style&index=0&id=5688b662&lang=css"

const __exports__ = script;

export default __exports__